import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ArchivoBean } from 'src/app/_beans/ArchivoBean';
import { AvanceBean } from 'src/app/_beans/AvanceBean';
import { UbigeoBean } from 'src/app/_beans/UbigeoBean';
import * as FileSaver from 'file-saver';
import { MetaBean } from 'src/app/_beans/MetaBean';
import { LenguaBean } from 'src/app/_beans/LenguaBean';
import { VarianteLenguaBean } from 'src/app/_beans/VarianteLengua';
import * as moment from 'moment';
import Swal, { SweetAlertIcon } from 'sweetalert2';
@Component({
  selector: 'app-avance-dialog',
  templateUrl: './avance-dialog.component.html',
  styleUrls: ['./avance-dialog.component.scss']
})
export class AvanceDialogComponent implements OnInit {
  titulo: string = "Agregar";
  avanceSelect: AvanceBean;
  regionesList: UbigeoBean[] = [];
  lenguaList: LenguaBean[] = [];
  varianteLenguaList: VarianteLenguaBean[] = [];
  provinciasList: UbigeoBean[] = [];
  distritoList: UbigeoBean[] = [];
  codigoRegion: string;
  archivosSubidos: any[] = [];
  objetivosMultiLevelList: any[] = [];
  archivoTamanio: any;
  variablePorMeta: any[] = [];
  esIndicadorPorObjetivo:boolean=false;
  constructor(
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private restProvider: RestProviderService,
    public constantes: ConstantesService,
    public dialogRef: MatDialogRef<AvanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AvanceBean,
  ) { }

  ngOnInit() {
    this.listarLenguas();
    this.listarRegiones();
      if (this.data.id) {
          this.titulo = "Editar";
          let params = {
            data: this.data
          }
          this.variablePorMeta=[];
          this.restProvider.executeHttpMethod("/ac/bpi", params).subscribe((result: any) => {
            this.avanceSelect = result.data;
            this.obtenerVariablesList(this.data.meta,this.avanceSelect.meta.variableMetaList);
            if(!this.avanceSelect.lengua){
              this.avanceSelect.lengua = new LenguaBean();
            }else{
              this.listarVarianteLenguas({value:this.avanceSelect.lengua.id});
            }
            if(!this.avanceSelect.varianteLengua){
              this.avanceSelect.varianteLengua = new VarianteLenguaBean();
            }
            this.avanceSelect.archivosList.forEach(data => {
              this.archivosSubidos.push(new File([""], "blanco"));
            })
            //this.variablePorMeta=this.avanceSelect.meta.variableMetaList;
            this.armarAtributosAdicionalSeleccionados();
            this.avanceSelect.meta.nombreDinamico = this.data.meta.nombreDinamico;
            this.avanceSelect.fechaAvance = this.sharedService.addTimeOffSet(this.avanceSelect.fechaAvance);
            if(this.avanceSelect.ubigeoRegion){
              let params2 = {
                value: {
                  codigoDepartamento: this.avanceSelect.ubigeoRegion.codigoDepartamento,
                }
              }
              this.listarProvinciasSegunIdRegion(params2);
              this.codigoRegion = this.avanceSelect.ubigeoRegion.codigoDepartamento;
            }
            if(this.avanceSelect.ubigeoProvincia){
              let params3 = {
                value: {
                  codigoProvincia: this.avanceSelect.ubigeoProvincia.codigoProvincia,
                }
              }
              this.listarDistritosSegunIdProvincia(params3);
            }
            this.cdr.markForCheck();
          }, error => {
            console.error(error);
          });
      } else {
        this.avanceSelect = new AvanceBean();
        if (this.data.abrirDesdeMenu) {
          this.obtenerTodosLosObjetivosPorIDConfiguracionPlan(this.sharedService.planSession.listaConfiguracionPlan[0].id);
          this.avanceSelect.meta = new MetaBean();
        } else {
          this.avanceSelect.meta = this.data.meta;
        }
        this.obtenerVariablesList(this.data.meta);
        this.avanceSelect.ubigeoDistrito = new UbigeoBean();
        this.avanceSelect.ubigeoProvincia = new UbigeoBean();
        this.avanceSelect.ubigeoRegion = new UbigeoBean();
        this.avanceSelect.lengua = new LenguaBean();
        this.avanceSelect.varianteLengua = new VarianteLenguaBean();
      }
  }

  public obtenerTodosLosObjetivosPorIDConfiguracionPlan(idConfPlan: number) {
    let params = {
      data: {
        configuracionPlan: {
          id: idConfPlan
        }
      }
    }
    this.sharedService.planSession.listaConfiguracionPlan.forEach(conf => {
      conf.objetivos = [];
      this.objetivosMultiLevelList.push(conf);
    })
    return new Promise((resolve, reject) => {
      this.restProvider.executeHttpMethod("/oc/lpicp", params).subscribe((result: any) => {
        this.objetivosMultiLevelList[0].objetivos = [];
        this.objetivosMultiLevelList[0].objetivos = result.datalist;
        resolve("success");
      });
    });
  }

  public seleccionarObjetivo(event: any, posicion: number) {
    if (event.value) {
      this.limpiarObjetivosList(posicion + 1);
      if (this.objetivosMultiLevelList.length - 2 > posicion){
        this.esIndicadorPorObjetivo=false;
        if(posicion==0){
          this.obtenerMetaListPorIdObjetivo(event.value.id, this.objetivosMultiLevelList.length-1);
          this.esIndicadorPorObjetivo=true;
        }
        this.obtenerTodosLosObjetivosPorIDObjetivoPadre(event.value.id, event.value.configuracionPlan.nivel);
      }
      else {
        if (this.objetivosMultiLevelList.length - 2 == posicion){
          this.obtenerMetaListPorIdObjetivo(event.value.id, event.value.configuracionPlan.nivel)
        }else {
          this.avanceSelect.meta = event.value;
          this.obtenerVariablesList(this.avanceSelect.meta);
        }
      }
    }
  }

  public obtenerVariablesList(meta: MetaBean,listaValores?:any[]){
    let params = {
      data: meta
    }
    this.restProvider.executeHttpMethod("/mc/bpi", params).subscribe((result: any) => {
      this.variablePorMeta= result.data.variableMetaList;
      this.variablePorMeta.forEach(data => {
        if (data.tipoDato == this.constantes.TIPO_DATO_LISTA || data.tipoDato == this.constantes.TIPO_DATO_LISTA_MULTIPLE) {
          if (data.valoresLista && data.valoresLista.length != 0) {
            let valorSplit = data.valoresLista.split(";");
            if (valorSplit && valorSplit.length > 0)
            data.valoresListaArray = valorSplit;
          }
          data.valoresListaSeleccionados=[];
        }
        if(listaValores){
          let idx= listaValores.findIndex((element)=>data.id==element.id);
          if(idx!=-1){
            data.valorVariableAvance=listaValores[idx].valorVariableAvance
          }
        }

      });
    }, error => {
      console.error(error);
    });
  }
  public limpiarObjetivosList(posicion: number) {
    this.avanceSelect.meta = new MetaBean();
    for (let index = posicion; index < this.objetivosMultiLevelList.length; index++)
      this.objetivosMultiLevelList[index].objetivos = [];
  }

  public obtenerMetaListPorIdObjetivo(idObjetivo: number, nivel: number) {
    let params = {
      data: {
        objetivo: {
          id: idObjetivo
        },
        idResponsable: this.sharedService.userSession?(this.sharedService.userSession.unidadOrganica?this.sharedService.userSession.unidadOrganica.id:undefined):undefined
      }
    }
    this.restProvider.executeHttpMethod("/mc/lpio", params).subscribe((result: any) => {
      this.objetivosMultiLevelList[nivel].objetivos = result.datalist;
    });
  }

  public obtenerTodosLosObjetivosPorIDObjetivoPadre(id: number, nivel?: number) {
    let params = {
      data: {
        objetivoPadre: {
          id: id
        }
      }
    }
    this.restProvider.executeHttpMethod("/oc/lpiop", params).subscribe((result: any) => {
      this.objetivosMultiLevelList[nivel].objetivos = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public armarAtributosAdicionalSeleccionados() {
    this.variablePorMeta.forEach(data => {
      if (data.valorVariableAvance) {
          if (data.tipoDato == this.constantes.TIPO_DATO_LISTA || data.tipoDato == this.constantes.TIPO_DATO_LISTA_MULTIPLE) {
            if (data.valoresLista && data.valoresLista.length != 0) {
              let valorSplit = data.valoresLista.split(";");
              if (valorSplit && valorSplit.length > 0)
              data.valoresListaArray = valorSplit;
            }
          }
          if (data.valorVariableAvance) {
              data.idValorMetaAdicionalBean = data.valorVariableAvance.id;
              if (data.tipoDato == this.constantes.TIPO_DATO_LISTA_MULTIPLE) {
                data.valoresListaSeleccionados = data.valorVariableAvance.valor.split(this.constantes.SEPARADOR);
              } else {
                data.valorIngresado =data.valorVariableAvance.valor;
              }
          }
      }
    });
  }

  public listarRegiones() {
    this.restProvider.executeHttpMethod("/ubc/lr", {}).subscribe((result: any) => {
      this.regionesList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public listarLenguas() {
    this.restProvider.executeHttpMethod("/lec/ll", {}).subscribe((result: any) => {
      this.lenguaList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public listarVarianteLenguas(event: any) {
    let params = {
      data: {
        id: event.value
      }
    }
    this.restProvider.executeHttpMethod("/vlec/lvl", params).subscribe((result: any) => {
      this.varianteLenguaList = result.datalist;
    }, error => {
      console.error(error);
    });
  }

  public listarProvinciasSegunIdRegion(event: any) {
    if (event.value) {
      let params = {
        data: {
          codigoDepartamento: event.value.codigoDepartamento
        }
      }
      this.restProvider.executeHttpMethod("/ubc/lp", params).subscribe((result: any) => {
        this.codigoRegion = event.value.codigoDepartamento
        this.provinciasList = result.datalist;
        this.distritoList = [];
      }, error => {
        console.error(error);
      });
    }
  }

  public listarDistritosSegunIdProvincia(event: any) {
    if (event.value) {
      let params = {
        data: {
          codigoProvincia: event.value.codigoProvincia,
          codigoDepartamento: this.codigoRegion
        }
      }
      this.restProvider.executeHttpMethod("/ubc/ld", params).subscribe((result: any) => {
        this.distritoList = result.datalist;
      }, error => {
        console.error(error);
      });
    }
  }


  public compararUbigeo(ubigeo: any, ubigeo2) {
    return ubigeo.id == ubigeo2.id;
  }

  public calcularPorcentajeAvanceSegunMeta(meta: any) {
    let params = {
      data: meta
    }
    this.restProvider.executeHttpMethod("/mc/cpa", params).subscribe((result: any) => {
      if (!this.data.abrirDesdeMenu)
        this.data.meta.avance = result.data.avance;
      this.calcularAvanceDesdePrimerNivel(meta.objetivo);
    });
  }

  public calcularAvanceDesdePrimerNivel(objetivo: any) {
    let params = {
      data: objetivo
    }
    this.restProvider.executeHttpMethod("/oc/capn", params).subscribe((result: any) => {
      if (this.sharedService.abrirSidebarObjetivos)
        this.sharedService.updateSidebarObjetivos.next("Update");
    });
  }

  public guardarAvance() {

    if(this.variablePorMeta==undefined){
      this.sharedService.showMessageWarn('Falta definir las variables del indicador');
      return;
    }

    let tamanioTotal = 0;
    this.archivosSubidos.forEach(archivos=> {
      tamanioTotal = tamanioTotal + archivos.size;
    });
    this.avanceSelect.valorVariableAvanceMetaList=[];
    this.variablePorMeta.forEach(variable=> {
      if(variable.tipoDato == this.constantes.TIPO_DATO_LISTA_MULTIPLE){
        variable.valorVariableAvance.valor = variable.valoresListaSeleccionados.join(this.constantes.SEPARADOR);
      }
      variable.valorVariableAvance.variableMeta={id:variable.id};
      this.avanceSelect.valorVariableAvanceMetaList.push(variable.valorVariableAvance);
    });
    this.avanceSelect.tamanioTotalArchivo = tamanioTotal;
    let fechaAvance: any;
    if(this.avanceSelect.fechaAvance instanceof moment) {
      fechaAvance = this.avanceSelect.fechaAvance;
      this.avanceSelect.fechaAvance = fechaAvance.toDate();
    }
    let params = {
      data: this.avanceSelect
    }
    this.restProvider.executeHttpMethod("/ac/g", params).subscribe((result: any) => {
        this.guardarArchivos(result.data.id).then(() => {
          if (!this.data.abrirDesdeMenu) {
            this.avanceSelect = result.data;
            //this.calcularPorcentajeAvanceSegunMeta(this.data.meta);
          } else {
            this.avanceSelect.esIndicadorPorObjetivo=this.esIndicadorPorObjetivo;
            //this.calcularPorcentajeAvanceSegunMeta(this.avanceSelect.meta);
          }
          let mensaje = "Se registró el avance con éxito , se ha enviado una notificación por correo electrónico a los responsables de aprobar el avance"
          let icon : SweetAlertIcon = "success"
          if(  !result.notificado ) { 
            mensaje = "Se registró el avance con éxito , no se pudo enviar la notificación por correo electrónico a los responsables de aprobar el avance"
            icon = "warning"
          }
          Swal.fire('Avance registrado', mensaje, icon);
          this.cerrar(this.avanceSelect);
        });
      }, error => {
        console.error(error);
        this.sharedService.showMessageWarn('Se ha excedido el tamaño total de 100 MB');
      });
  }

  public cerrar(avance?: AvanceBean) {
    let nombreMeta = '';
    if (this.data.abrirDesdeMenu) {
      nombreMeta = this.objetivosMultiLevelList[this.objetivosMultiLevelList.length - 1].nombre;
    }
    avance ? this.dialogRef.close({ avance: avance, nombreMeta: nombreMeta }) : this.dialogRef.close();
  }

  public cargarArchivo(event) {
    let archivo = new ArchivoBean();
    let tamanioFile: any = event.target.files[0].size;
    archivo.nombre = event.target.files[0].name;

    if (tamanioFile > this.constantes.MAX_TAMANIO_ARCHIVO) {
      this.sharedService.showMessageWarn('Se ha excedido los 30 MB');
      return;
    }

    if (archivo.nombre.toLowerCase().endsWith(".bat") || archivo.nombre.toLowerCase().endsWith(".exe") || archivo.nombre.toLowerCase().endsWith(".zip")) {
      this.sharedService.showMessageWarn('Tipo de archivo no permitido');
      return;
    }

    if (tamanioFile === 0) {
      tamanioFile = '0 Bytes';
    } else {
      let k = 1024;
      let decimals = 2;
      let sizes = ['Bytes', 'KB', 'MB'];
      let i = Math.floor(Math.log(tamanioFile) / Math.log(k));
      tamanioFile = parseFloat((tamanioFile / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
    }

    archivo.tamanio = tamanioFile;
    this.avanceSelect.archivosList.push(archivo)
    this.archivosSubidos.push(event.target.files[0]);

  }

  public guardarArchivos(idAvance: number): Promise<any> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (this.archivosSubidos.length > 0) {
            const formData = new FormData();
            let avanceBean = new AvanceBean();
            avanceBean.id = idAvance
            formData.append("avance", JSON.stringify(avanceBean));
            this.archivosSubidos.forEach((file: File, idx) => {
              if (file.size > 0)
                formData.append(file.name, file);
            })
            this.restProvider.executeHttpMethod('/arc/ga', formData, true).subscribe(result => {
              resolve("Succes");
            });
          } else {
            resolve("Succes");
          }
      }, 0);
    });
  }

  public eliminarArchivoSeleccionado(index, archivo: ArchivoBean) {
    if (archivo.id) {
      let params = {
        data: {
          id: archivo.id
        }
      }
      this.restProvider.executeHttpMethod('/arc/e', params).subscribe(result => {
        this.archivosSubidos.splice(index, 1);
        this.avanceSelect.archivosList.splice(index, 1);
      });
    } else {
      this.archivosSubidos.splice(index, 1);
      this.avanceSelect.archivosList.splice(index, 1);
    }
  }

  public descargarArchivoSeleccionado(archivo: ArchivoBean): void {
    let params = {
      data: {
        id: archivo.id
      }
    }
    this.restProvider.getFile("/arc/das", params).subscribe(result => {
      FileSaver.saveAs(new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), archivo.nombre);
    }, error => {
      console.error(error);
    });
  }

  public validarCampos() {
    if (this.avanceSelect.descripcion && this.avanceSelect.meta.id && this.avanceSelect.fechaAvance) {
      return false;
    } else {
      return true;
    }
  }


}
